import { Link } from 'react-router-dom';

export default function SellCarComparison() {
  return (
    <section className="py-16 bg-[#F7F5F0]">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <h2 style={{ fontFamily: 'Oswald, sans-serif' }} className="text-3xl md:text-4xl font-bold text-[#1A2332] mb-4">
              Your Options (Ranked by Headache Level)
            </h2>
            <p className="text-lg text-[#4A5568] max-w-2xl mx-auto">
              Selling a car is never fun, but some methods are way worse than others. Here's the honest breakdown.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {/* Private Sale */}
            <div className="bg-white rounded-xl p-6 border-2 border-[#E8E2D6]">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-xl font-bold text-[#1A2332]">Private Sale</h3>
                <div className="text-2xl">😰</div>
              </div>
              <div className="space-y-3 mb-6">
                <div className="flex items-start gap-2">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <span className="text-sm text-[#4A5568]">Highest potential price</span>
                </div>
                <div className="flex items-start gap-2">
                  <i className="ri-close-line text-red-500 mt-1"></i>
                  <span className="text-sm text-[#4A5568]">Endless "is this available?" texts</span>
                </div>
                <div className="flex items-start gap-2">
                  <i className="ri-close-line text-red-500 mt-1"></i>
                  <span className="text-sm text-[#4A5568]">Strangers test-driving your car</span>
                </div>
                <div className="flex items-start gap-2">
                  <i className="ri-close-line text-red-500 mt-1"></i>
                  <span className="text-sm text-[#4A5568]">Payment scams and lowball offers</span>
                </div>
                <div className="flex items-start gap-2">
                  <i className="ri-close-line text-red-500 mt-1"></i>
                  <span className="text-sm text-[#4A5568]">Takes weeks or months</span>
                </div>
              </div>
              <div className="text-sm font-semibold text-[#1A2332] bg-[#F7F5F0] px-4 py-2 rounded-lg text-center">
                Best for: People with infinite patience
              </div>
            </div>

            {/* Traditional Dealer */}
            <div className="bg-white rounded-xl p-6 border-2 border-[#E8E2D6]">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-xl font-bold text-[#1A2332]">Traditional Dealer</h3>
                <div className="text-2xl">😤</div>
              </div>
              <div className="space-y-3 mb-6">
                <div className="flex items-start gap-2">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <span className="text-sm text-[#4A5568]">Quick process</span>
                </div>
                <div className="flex items-start gap-2">
                  <i className="ri-close-line text-red-500 mt-1"></i>
                  <span className="text-sm text-[#4A5568]">Lowball offers (like, insultingly low)</span>
                </div>
                <div className="flex items-start gap-2">
                  <i className="ri-close-line text-red-500 mt-1"></i>
                  <span className="text-sm text-[#4A5568]">"Let me talk to my manager" games</span>
                </div>
                <div className="flex items-start gap-2">
                  <i className="ri-close-line text-red-500 mt-1"></i>
                  <span className="text-sm text-[#4A5568]">Pressure to buy something from them</span>
                </div>
                <div className="flex items-start gap-2">
                  <i className="ri-close-line text-red-500 mt-1"></i>
                  <span className="text-sm text-[#4A5568]">Hidden "reconditioning fees"</span>
                </div>
              </div>
              <div className="text-sm font-semibold text-[#1A2332] bg-[#F7F5F0] px-4 py-2 rounded-lg text-center">
                Best for: People who enjoy being annoyed
              </div>
            </div>

            {/* Rockhound Auto */}
            <div className="bg-gradient-to-br from-[#E8B84B]/10 to-[#E8B84B]/20 rounded-xl p-6 border-2 border-[#E8B84B] relative">
              <div className="absolute -top-3 -right-3 bg-[#E8B84B] text-[#1A2332] px-3 py-1 rounded-full text-xs font-bold">
                BEST OPTION
              </div>
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-xl font-bold text-[#1A2332]">Rockhound Auto</h3>
                <div className="text-2xl">😎</div>
              </div>
              <div className="space-y-3 mb-6">
                <div className="flex items-start gap-2">
                  <i className="ri-check-line text-[#E8B84B] mt-1"></i>
                  <span className="text-sm text-[#1A2332]">Fair market offer in 24 hours</span>
                </div>
                <div className="flex items-start gap-2">
                  <i className="ri-check-line text-[#E8B84B] mt-1"></i>
                  <span className="text-sm text-[#1A2332]">No pressure to buy from us</span>
                </div>
                <div className="flex items-start gap-2">
                  <i className="ri-check-line text-[#E8B84B] mt-1"></i>
                  <span className="text-sm text-[#1A2332]">Transparent pricing breakdown</span>
                </div>
                <div className="flex items-start gap-2">
                  <i className="ri-check-line text-[#E8B84B] mt-1"></i>
                  <span className="text-sm text-[#1A2332]">Cash in hand, done deal</span>
                </div>
                <div className="flex items-start gap-2">
                  <i className="ri-check-line text-[#E8B84B] mt-1"></i>
                  <span className="text-sm text-[#1A2332]">Zero fees or surprise deductions</span>
                </div>
              </div>
              <div className="text-sm font-semibold text-[#1A2332] bg-white px-4 py-2 rounded-lg text-center">
                Best for: People who value their time
              </div>
            </div>
          </div>

          <div className="mt-12 text-center">
            <Link
              to="/sell-your-car#form"
              className="inline-flex items-center gap-2 bg-[#E8B84B] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#D4A43A] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              Get Your Fair Offer Now
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}